import React from 'react';
import { MapPin, Mail, Phone, Clock } from 'lucide-react';

const Footer1 = () => {
    return (
        <footer className="bg-gray-900 text-white py-10">
            <div className="container mx-auto px-6">
                <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
                    <div>
                        <h3 className="text-xl font-bold mb-4">
                            <span className="text-orange-400">Sparkle X</span><span className="text-blue-400">xpress</span>
                        </h3>
                        <p className="opacity-75 mb-4 text-sm">
                            Professional laundry services delivering exceptional cleanliness and convenience to busy professionals and families.
                        </p>
                        <div className="flex space-x-5 mt-3">
                            <a href="https://facebook.com" className="hover:text-orange-400 transition-colors" aria-label="Facebook">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path></svg>
                            </a>
                            <a href="https://whatsapp.com" className="hover:text-orange-400 transition-colors" aria-label="WhatsApp">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M17.498 14.382c-.301-.15-1.767-.867-2.04-.966-.273-.101-.473-.15-.673.15-.197.295-.771.964-.944 1.162-.175.195-.349.21-.646.075-.3-.15-1.263-.465-2.403-1.485-.888-.795-1.484-1.77-1.66-2.07-.174-.3-.019-.465.13-.615.136-.135.301-.345.451-.523.146-.181.194-.301.297-.496.1-.21.049-.375-.025-.524-.075-.15-.672-1.62-.922-2.206-.24-.584-.487-.51-.672-.51-.172-.015-.371-.015-.571-.015-.2 0-.523.074-.797.359-.273.3-1.045 1.02-1.045 2.475s1.07 2.865 1.219 3.075c.149.195 2.105 3.195 5.1 4.485.714.3 1.27.48 1.704.629.714.227 1.365.195 1.88.121.574-.091 1.767-.721 2.016-1.426.255-.705.255-1.29.18-1.425-.074-.135-.27-.21-.57-.345z" /><path d="M20.52 3.449C18.24 1.245 15.24 0 12.045 0 5.463 0 .104 5.334.101 11.893c0 2.096.549 4.14 1.595 5.945L0 24l6.335-1.652c1.746.943 3.71 1.444 5.71 1.447h.006c6.585 0 11.946-5.336 11.949-11.896 0-3.176-1.24-6.165-3.495-8.411zm-8.475 18.246h-.006a9.847 9.847 0 01-5.02-1.372l-.36-.214-3.726.975 1.013-3.681-.244-.372a9.828 9.828 0 01-1.51-5.26c.003-5.431 4.428-9.847 9.872-9.847 2.634 0 5.11 1.025 6.967 2.886 1.857 1.86 2.88 4.329 2.878 6.963-.004 5.433-4.428 9.85-9.868 9.85z" /></svg>
                            </a>
                            <a href="https://maps.google.com" className="hover:text-orange-400 transition-colors" aria-label="Google Maps">
                                <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 24 24"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5a2.5 2.5 0 1 1 0-5 2.5 2.5 0 0 1 0 5z" /></svg>
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-base font-bold mb-4 text-orange-400">Quick Links</h4>
                        <ul className="space-y-2 text-sm">
                            <li>
                                <a
                                    href="/"
                                    className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                                >
                                    Home
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/#services"
                                    className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                                >
                                    Services
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/#pricing"
                                    className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                                >
                                    Pricing
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/#testimonials"
                                    className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                                >
                                    Testimonials
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/#contact"
                                    className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                                >
                                    Contact
                                </a>
                            </li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="text-base font-bold mb-4 text-orange-400">Our Services</h4>
                        <div className="grid grid-cols-2 gap-x-4 gap-y-2 text-sm">
                            <a
                                href="/#services"
                                className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                            >
                                Dry Cleaning
                            </a>
                            <a
                                href="/#services"
                                className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                            >
                                Steam Ironing
                            </a>
                            <a
                                href="/#services"
                                className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                            >
                                Wash & Iron
                            </a>
                            <a
                                href="/#services"
                                className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                            >
                                Wash & Fold
                            </a>
                            <a
                                href="/#services"
                                className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                            >
                                Carpet Cleaning
                            </a>
                            <a
                                href="/#services"
                                className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                            >
                                Curtain Cleaning
                            </a>
                            <a
                                href="/#services"
                                className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                            >
                                Shoe Cleaning
                            </a>
                            <a
                                href="/#services"
                                className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors"
                            >
                                Leather Cleaning
                            </a>
                        </div>
                    </div>

                    <div>
                        <h4 className="text-base font-bold mb-4 text-orange-400">Contact Info</h4>
                        <ul className="space-y-3 text-sm">
                            <li className="flex items-start">
                                <MapPin size={16} className="text-blue-400 mr-2 mt-1 flex-shrink-0" />
                                <span className="opacity-75">Galaxy Apartment, Osman Nagar Road, Serilingampally, Hyderabad 500019</span>
                            </li>
                            <li className="flex items-start">
                                <Mail size={16} className="text-blue-400 mr-2 mt-1 flex-shrink-0" />
                                <a href="mailto:sparklexpresslaundry@gmail.com" className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors">
                                    sparklexpresslaundry@gmail.com
                                </a>
                            </li>
                            <li className="flex items-start">
                                <Phone size={16} className="text-blue-400 mr-2 mt-1 flex-shrink-0" />
                                <a href="tel:+919618030594" className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors">
                                    +91 96180 30594
                                </a>
                            </li>
                            <li className="flex items-start">
                                <Clock size={16} className="text-blue-400 mr-2 mt-1 flex-shrink-0" />
                                <span className="opacity-75">Open 8:00 AM - 8:00 PM Mon-Sat</span>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className="border-t border-gray-800 mt-8 pt-6 flex flex-col md:flex-row justify-between items-center">
                    <div className="text-center md:text-left">
                        <p className="opacity-75 text-xs">© {new Date().getFullYear()} Sparkle Xxpress Laundry. All rights reserved.</p>
                        <p className="opacity-75 text-xs mt-1">Designed & Developed by <a href="https://alphaaiservice.com/" target='_blank' rel="noopener noreferrer"><span className="text-blue-400">Alpha AI Service</span></a></p>
                    </div>
                    <div className="mt-3 md:mt-0">
                        <ul className="flex space-x-4 text-xs">
                            <li><a href="/privacy" className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors">Privacy Policy</a></li>
                            <li><a href="/terms" className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors">Terms & Conditions</a></li>
                            <li><a href="/faq" className="opacity-75 hover:opacity-100 hover:text-blue-400 transition-colors">FAQs</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer1;